<script setup>

import KdContainer from "./kdContainer.vue";
import KdVinInput from "./kdVinInput.vue";

</script>

<template>
  <kd-container>
    <el-form :model="form" :rules="rules" ref="formRef" label-width="170px">
      <div v-show="form.hasMarketVehicle == 1">
        <el-form-item label="未发物料处置方案" prop="inventoryVehicleDisposalSolution">
          <el-input :disabled="marketVehicles && marketVehicles.marketVehicleDisposalSolution !== ''" placeholder="请输入未发物料处置方案"
                    v-model="form.marketVehicleDisposalSolution"
                    type="textarea" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
        </el-form-item>
        <div v-if="marketVehicles && marketVehicles.marketVehicleDisposalSolutionFiles != undefined && marketVehicles.marketVehicleDisposalSolutionFiles.length > 0">
          <el-form-item label="附件">
            <file-upload-list
              v-if="marketVehicles && marketVehicles.marketVehicleDisposalSolutionFiles != undefined"
              ref="fileUploadList"
              :fileList="form.marketVehicleDisposalSolutionFiles"
            ></file-upload-list>
            <drag-upload
              v-else
              ref="uploadFile"
              :accessoryList.sync="form.marketVehicleDisposalSolutionFiles"
              :httpRequest="imAction"/>
          </el-form-item>
        </div>
      </div>
      <el-form-item label="未发物料处理情况" prop="marketVehicleHandStatusMessage">
        <el-input  v-model="form.marketVehicleHandStatusMessage" type="textarea" placeholder="请输入未发物料处理情况"
                  :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="lang-but" type="primary" @click="auditPassBtClick"
        >通过</el-button
        >
        <el-button v-show="taskDefKey!= 'Activity_1klkn9j' " class="lang-but" type="danger" @click="auditRejectBtClick"
        >驳回</el-button
        >
      </el-form-item>
    </el-form>

    <kd-audit-pass-dialog
      :visible.sync="auditPassDialogVisible"
      v-model="form.auditText"
      @confirm="onAuditPassConfirm"
    />

    <div>
      <el-dialog width="600px !important" title="审核驳回" :visible.sync="dialogVisible">
        <el-form :model="form" :rules="rules" ref="rejectFormRef" label-width="85px">
          <el-form-item label="驳回原因" prop="rejectReason">
            <el-input v-model="form.rejectReason" type="textarea" placeholder="请输入驳回原因" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
          </el-form-item>
          <div class="submitArea">
            <el-button type="primary" @click="auditRejectSubmit()">提交</el-button>
            <el-button plain  @click="dialogVisible = false">取消</el-button>
          </div>
        </el-form>
      </el-dialog>
    </div>
  </kd-container>
</template>

<style scoped lang="scss">

</style>
<script>
import {requestSubmitAudit} from "../../api/feedback";
import {requestSubmitAuditKD} from "@/api/feedbackKD";
import KdAuditPassDialog from "./kdAuditPassDialog.vue";

/**
 * 18.3-质量经理发起召回
 */
export default {
  name: "qualityManagerInitiateRecallAudit",
  components: { KdAuditPassDialog },
    props: {
      taskId:String,
      questionId:String,
      taskDefKey:String,
      marketVehicles: Object,
      initForm:{
        type: Boolean,
        default: false
      },
      disableForm:{
        type: Boolean,
        default: false
      },
      receivedForm:{
        handSuggestion:{
          type: String,
          default: ""
        },
        handSuggestionFiles:{
          type: Array,
          default: undefined
        },
        permanentSolution:{
          type: String,
          default: ""
        },
        hasMarketVehicle:{
          type:Number,
          default: undefined
        },
        marketVehicleDisposalSolution:{
          type: String,
          default: ""
        },

        marketVehicleDisposalSolutionFiles:{
          type: Array,
          default: undefined
        },
        hasInventoryVehicle:{
          type:Number,
          default: undefined
        },
        inventoryVehicleDisposalSolution:{
          type: String,
          default: ""
        },
        inventoryVehicleDisposalSolutionFiles:{
          type: Array,
          default: undefined
        },
        hasQualityProblem:{
          type:Number,
          default: undefined
        },
        reasonAnalystMaterial:{
          type: String,
          default: ""
        },
        reasonAnalyst: {
          type:String,
          default: ""
        },
        requestCompletionProcess:{
          type:Number,
          default: undefined
        },
        practicalBreakpointTime:{
          type:String,
          default: ""
        },
        pdiCheckContent:{
          type: String,
          default: ""
        },
        pdiCheckResult:{
          type: String,
          default: ""
        },
        pdiCheckResultFiles:{
          type: Array,
          default: undefined
        },
        files:Array
      }
    },
  data() {
    return {
      header: {
        satoken: sessionStorage.getItem("token")
      },
      imAction: "/manage/staff/upload?fileType=auditResource",
      assignUser:"",
      dialogVisible:false,
      auditPassDialogVisible: false,
      form:{
        marketVehicleDisposalSolutionFiles:[],
        hasInventoryVehicle: "",
        hasMarketVehicle: 1,
        marketVehicleDisposalSolution: "",
        handSuggestion: "",
        inventoryVehicleHandStatusMessage: "",
        marketVehicleHandStatusMessage: "",
        claimResult: "",
        handSuggestionFiles:[],
        rejectReason:"",
        auditText: "",
      },
      rules: {
        hasMarketVehicle: [
          { required: true, message: "是否存在KD工厂物料不能为空", trigger: ["blur", "change"] }
        ],
        marketVehicleDisposalSolution: [
          { required: true, message: "KD工厂物料处置方案不能为空", trigger: ["blur", "change"] }
        ],

        rejectReason: [
          { required: true, message: "驳回原因不能为空", trigger: ["blur", "change"] }
        ]
      }
    }
  },
  watch: {
    hasTempSolution: function (val) {
      this.$emit("hasTempSolution", val);
    },
    "form.hasMarketVehicle"(newVal) {
      this.form.marketVehicleDisposalSolution = this.marketVehicles.marketVehicleDisposalSolution??"";
      if (newVal == 0) {
        this.$set(this.rules, "marketVehicleDisposalSolution", []);
        this.$refs.formRef.clearValidate("marketVehicleDisposalSolution");
      } else {
        this.$set(this.rules, "marketVehicleDisposalSolution", [{  required: true, message: "KD工厂物料处置方案不能为空", trigger: ["blur", "change"] }]);
      }
    },
  },
  methods: {
    submitDataBtClick() {
      this.$confirm('确认提交吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let formData = {
          taskId:this.taskId,
          variables: {
            approval: true,
          },
          vins:this.form.vinDatas.map(item=>item.vin),
          marketVehicles: this.form,
        }
        requestSubmitAuditKD(formData).then(res => {
          if(res.status == "0"){
            this.$DonMessage.success('提交成功!');
            this.backRouterPath();
          }
        })
      })
    },
    auditPassBtClick() {
      this.$refs['formRef'].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)){
          return
        }
        this.auditPassDialogVisible = true;
      })

    },
    onAuditPassConfirm(auditText) {
      let formData = {
        nowTaskId: this.taskId,
        questionId: this.questionId,
        taskDefKey: this.taskDefKey,
        auditText: auditText,
        marketVehicles: this.form,
        variables: {
          approval: true,
        },
      }
      requestSubmitAuditKD(formData).then(res => {
        if (res.status == "0") {
          this.$DonMessage.success('审批通过成功!');
          this.backRouterPath();
        }else {
          this.$DonMessage.error(res.message);
        }
      })
    },
    auditRejectBtClick() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.rejectFormRef?.resetFields();
      })
    },
    auditRejectSubmit(){
      this.$refs['rejectFormRef'].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)){
          return
        }
        let formData = {
          nowTaskId: this.taskId,
          questionId: this.questionId,
          taskDefKey: this.taskDefKey,
          auditText: this.form.rejectReason,
          variables: {
            approval: false
          },
        }
        requestSubmitAuditKD(formData).then(res => {
          if (res.status == "0") {
            this.$DonMessage.success('驳回成功!');
            this.backRouterPath();
            this.dialogVisible = false;
          } else {
            this.$DonMessage.error(res.message);
          }
        })
      })

    },
  },
  mounted() {
    if(this.marketVehicles){
      this.form.hasMarketVehicle = (this.marketVehicles.hasMarketVehicle)?Number(this.marketVehicles.hasMarketVehicle):0;
      this.form.hasInventoryVehicle = (this.marketVehicles.hasInventoryVehicle)?Number(this.marketVehicles.hasInventoryVehicle):0;
      this.form.marketVehicleDisposalSolution = this.marketVehicles.marketVehicleDisposalSolution??"";
      this.form.marketVehicleDisposalSolutionFiles = this.marketVehicles.marketVehicleDisposalSolutionFiles??[];
      this.form.inventoryVehicleDisposalSolution = this.marketVehicles.inventoryVehicleDisposalSolution??"";
      this.form.inventoryVehicleDisposalSolutionFiles = this.marketVehicles.inventoryVehicleDisposalSolutionFiles??[];
      this.form.handSuggestion = this.marketVehicles.handSuggestion??"";
      this.form.inventoryVehicleHandStatusMessage = this.marketVehicles.inventoryVehicleHandStatusMessage??"";
      this.form.claimResult = "";
      this.form.handSuggestionFiles = this.marketVehicles.handSuggestionFiles??[];
    }
  }
}
</script>
